import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import { clearAdminAccountSearch, searchAccounts } from '../../../actions/adminActions';

class AccountsSearch extends Component {
  static propTypes = {
    clearAdminAccountSearch: PropTypes.func,
    searchAccounts: PropTypes.func,
    isAdminAcccountSearched: PropTypes.bool,
    adminAccountSearchQuery: PropTypes.instanceOf(Object),
    isClearAdminAccountSearch: PropTypes.bool,
    setSortKeyOnClear: PropTypes.func,
  }

  static defaultProps = {
    isAdminAcccountSearched: false,
    isClearAdminAccountSearch: false,
    adminAccountSearchQuery: {},
  }

  constructor() {
    super();
    this.state = {
      searchTerm: {
        query: '',
        pageNo: '1',
      },
    };
    this.servicesValue = _.debounce(this.servicesValue, 500);
  }

  UNSAFE_componentWillReceiveProps({
    adminAccountSearchQuery,
    isClearAdminAccountSearch,
    isAdminAcccountSearched,
  }) {
    if (isAdminAcccountSearched && !isClearAdminAccountSearch) {
      this.updateSearchQuery(adminAccountSearchQuery);
    }

    if (!isAdminAcccountSearched && isClearAdminAccountSearch) {
      this.setState({
        searchTerm: {
          query: '',
          pageNo: '1',
          sortBy:'accountName',
          sortOrder:'asc',
          
        },
      }, () => {
        this.handleSearch();
      });
    }
  }

  updateSearchQuery = adminAccountSearchQuery => {
    const { searchTerm } = this.state;
    if (!_.isEmpty(adminAccountSearchQuery)) {
      const queryObj = _.cloneDeep(adminAccountSearchQuery);
      const updatedSearchTerm = { ...searchTerm, ...queryObj };
      this.setState({ searchTerm: updatedSearchTerm });
    }
  }

  handleQueryChange = query => {
    const { searchTerm } = this.state;
    this.setState({
      searchTerm: {
        ...searchTerm,
        query,
      },
    }, () => {
      if (query.trim()) {
        this.servicesValue();
      }
    });
  }

  servicesValue = () => {
    this.handleSearch();
  }

  clearQuery = () => {
    const { searchTerm } = this.state;
    this.setState({
      searchTerm: {
        ...searchTerm,
        query: '',
      },
    }, () => {
      this.handleSearch();
    });
  }

  handleSearch = e => {
    if (e) {
      e.preventDefault();
    }
    const searchTerm = _.cloneDeep(this.state.searchTerm);
    searchTerm.query = searchTerm.query.trim();
    this.props.searchAccounts(searchTerm);
  }

  clearSearch = () => {
    this.props.setSortKeyOnClear();
    this.props.clearAdminAccountSearch();
  }

  render() {
    const { searchTerm } = this.state;
    const { query } = searchTerm;
    const { isAdminAcccountSearched } = this.props;
    return (
      <div className="user-search user-search--horizontal">
        <form onSubmit={this.handleSearch}>
          <div className="user-search--box">
            <div className="user-search--form">
              <div className="user-search--form-group">
                <label className="sr-only" htmlFor="searchQuery">Search by account name...</label>
                <input
                  type="text"
                  className="form-control"
                  value={query}
                  id="searchQuery"
                  name="searchQuery"
                  onChange={e => this.handleQueryChange(e.target.value)}
                  placeholder="Search by account name..."
                  autoComplete="off"
                />
                { query && (
                  <button type="button" onClick={this.clearQuery} className="user-search--form-clear">
                    <i className="clear-x-icon" />
                  </button>
                  )
                }
              </div>
            </div>
            <div className="user-search--form--footer">
              {
                isAdminAcccountSearched && (
                  <button type="button" onClick={this.clearSearch} className="button primary">Clear</button>
                )
              }
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = ({ admin }) => {
  return {
    adminAccountSearchQuery: admin.adminAccountSearchQuery,
    isClearAdminAccountSearch: admin.isClearAdminAccountSearch,
    isAdminAcccountSearched: admin.isAdminAcccountSearched,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    searchAccounts: bindActionCreators(searchAccounts, dispatch),
    clearAdminAccountSearch: bindActionCreators(clearAdminAccountSearch, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountsSearch);

